/** API route map: URLS.Controller.InviteUser */
export const InviteUser = {
      Name: 'InviteUser/',
      GetAllActiveEmployees: 'active-employees',
      GetLocationList: 'get-locations',
      AddUser: 'add',
      getUser: 'get',
      AddUserEducation: 'add-education',
      UpdateUserEducation: 'update-education',
      AddUserExperence: 'add-experence',
      UpdateUserExperence: 'update-experence',
      AddEmergencyConact: 'add-emergency-contact',
      UpdateEmergencyConact: 'update-emergency-contact',
      getPersonalDetail: 'header-summary',
      updatePersonalDetail: 'patch-information',
      deleteUser: 'delete',
      GetAllTabCounts: 'get-user-tab-count',
};
